import {faSpinnerThird} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import * as styles from './review-catalog-logo.scss';

type PropsType = {
    logoUrl?: string;
    isCatalogLoading: boolean;
};

export function ReviewCatalogLogo(props: PropsType): JSX.Element | null {
    const {isCatalogLoading, logoUrl} = props;

    if (isCatalogLoading) {
        return (
            <div className={styles.review_catalog_logo__loading}>
                <FontAwesomeIcon icon={faSpinnerThird} spin />
            </div>
        );
    }

    if (!logoUrl) {
        return null;
    }

    return <img alt="" className={styles.review_catalog_logo} src={logoUrl} />;
}
